import { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HomepageContext = createContext(null);

const ROTATION_MAP = {
  'value': '/',
  'solutions': '/products',
  'technology': '/platform',
  'evaluate': '/evaluate',
  'sap-s4hana': '/sap-s4hana',
  'resources': '/insights',
};

const LABEL_MAP = {
  'value': 'Value',
  'solutions': 'Solutions',
  'technology': 'Technology',
  'evaluate': 'Evaluate',
  'sap-s4hana': 'SAP S/4HANA',
  'resources': 'Resources',
};

export const HomepageProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('value');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/homepage/current`)
      .then(res => res.json())
      .then(data => {
        setCurrentPage(data.current_page || 'value');
      })
      .catch(() => {
        setCurrentPage('value');
      })
      .finally(() => setLoading(false));
  }, []);

  const value = {
    currentPage,
    setCurrentPage,
    loading,
    isHomepage: (pageId) => currentPage === pageId,
    getNavLabel: (pageId) => LABEL_MAP[pageId] || pageId,
    getOriginalPath: (pageId) => ROTATION_MAP[pageId] || '/',
  };

  return (
    <HomepageContext.Provider value={value}>
      {children}
    </HomepageContext.Provider>
  );
};

export const useHomepage = () => {
  const ctx = useContext(HomepageContext);
  if (!ctx) throw new Error('useHomepage must be used within HomepageProvider');
  return ctx;
};
